import { render, staticRenderFns } from "./Wp_options_filter_page.vue?vue&type=template&id=25d3d156&scoped=true&"
import script from "./Wp_options_filter_page.vue?vue&type=script&lang=js&"
export * from "./Wp_options_filter_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d3d156",
  null
  
)

export default component.exports